<template>
  <div>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title>
          <app-title>Create Manual Commission</app-title>
        </v-card-title>

        <v-card-text>
          <v-row>
            <v-col class="col-12" md="3">
              <v-text-field
                label="Customer Number"
                type="number"
                name="custNo"
                v-validate="'required|numeric'"
                :error-messages="errors.collect('custNo')"
                v-model.number="editedItem.custNo"
              ></v-text-field>
            </v-col>
            <v-col class="col-12" md="3">
              <v-text-field
                label="CSN"
                name="csn"
                v-model="editedItem.csn"
                v-validate="'required'"
                :error-messages="errors.collect('csn')"
              ></v-text-field>
            </v-col>
            <v-col class="col-12" md="3">
              <v-text-field
                label="Run Number"
                type="number"
                name="runId"
                v-model.number="editedItem.runId"
                v-validate="'required|numeric'"
                :error-messages="errors.collect('runId')"
              ></v-text-field>
            </v-col>
            <v-col class="col-12" md="3">
              <v-text-field
                label="Dealer"
                type="number"
                name="dealerID"
                v-validate="'required|numeric'"
                :error-messages="errors.collect('dealerID')"
                v-model.number="editedItem.dealerId"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="col-9" md="9">
              <v-text-field label="Comment" v-model="editedItem.comment"></v-text-field>
            </v-col>
            <v-col class="col-1" md="1">
              <v-text-field
                label="Summary Level"
                type="number"
                v-model.number="editedItem.summaryLevel"
                v-validate="'required|numeric'"
                name="summaryLevel"
                :error-messages="errors.collect('summaryLevel')"
              ></v-text-field>
            </v-col>
            <v-col class="col-2" md="2">
              <v-text-field
                label="Amount"
                type="number"
                name="amount"
                v-validate="'required|decimal'"
                :error-messages="errors.collect('amount')"
                prefix="$"
                v-model.number="editedItem.amount"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="primary" @click.native="editItem()">Save</v-btn>

          <v-btn color="light-grey" @click="dialog = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "ManualAdjustment",

  data() {
    return {
      dialog: false,
      editedItem: {},
    };
  },
  methods: {
    ...mapActions("commissions", ["CommissionsRequest", "updateSummary"]),

    editItem() {
      let vm = this;
      this.$validator.validateAll().then((result) => {
        if (result) {
          vm.updateSummary(vm.editedItem)
            .then((data) => {
              vm.dialog = false;
              vm.$emit("refresh", data);
            })
            .catch(() => {});
        }
      });
    },
    openDialog(item) {
      this.dialog = true;

      if (item) this.editedItem = item;
      else {
        this.editedItem = {
          amount: 0,
          chargeLineid: 0,
          comment: "",
          csn: "",
          custAdded: null,
          custNo: 0,
          custRequired: null,
          dealerElligibleTotal: null,
          dealerId: this.details[0].dealerId,
          eligibleAmount: null,
          elligibleIpbonus: null,
          id: 0,
          ipbonusAmt: null,
          manualEntry: true,
          percentageApplied: null,
          ratePlanId: 0,
          runDate: new Date(),
          runId: this.details[0].runId,
          runType: this.details[0].runType,
          servicesAddedThisMonth: null,
          summaryLevel: 1,
        };
      }
    },
  },
};
</script>

<style scoped></style>
